import { FC } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';

const Instruction:FC = () => {
  const { t } = useTranslation('common');

  return (
    <div
      className="p-4 text-white text-base font-semibold"
    >
      <Trans
        components={{
          a1: <a rel="noreferrer" className="uppercase text-primary font-bold hover:underline" href="https://quizwizards.com/QuizWizards-How-To-Guide.pdf" target="_blank"> </a>,
          a2: <a rel="noreferrer" className="uppercase text-primary font-bold hover:underline" href="https://quizwizards.com/QuizWizards-Video-How-To-Guide.pdf" target="_blank"> </a>,
        }}
        i18nKey={t('ownerPage.quizForm.instructions')}
      />
    </div>
  )
}

export default Instruction;
